export const styleClasses = (componentPrefix, props) => {
    const propMap = Object.entries(props);
    if (propMap.length === 0) {
        return componentPrefix;
    }
    return (propMap
        .map(([key, value]) => `${componentPrefix}-${key}-${value}`)
        .join(" ") + ` ${componentPrefix}`);
};
/**
 * For a given popup element, creates a listener that closes it if a user clicks outside that popup.
 * @param popupElementSelector A CSS selector string that corresponds to the popup element
 * @param popupOpenerSelector A CSS selector string that corresponds to the element that triggers the popup
 * @param closeAction A callback that, when called, closes the popup element. To be called when a click happens outside the popup.
 */
export const listenForPopupCloseClick = (popupElementSelector, popupOpenerSelector, closeAction) => {
    const eventListener = ({ target }) => {
        const popupElement = document.querySelector(popupElementSelector);
        const popupOpeners = document.querySelectorAll(popupOpenerSelector);
        // If either the popup element or any inputs on the page were clicked in, leave popup open and requeue listener
        // This has an intentional side effect of not interfering with the setState call that is made when directly opening
        // an input while another was already opened.
        if ((popupElement === null || popupElement === void 0 ? void 0 : popupElement.contains(target)) ||
            [...popupOpeners].some((element) => element.contains(target))) {
            document.body.addEventListener("click", eventListener, {
                once: true,
            });
        }
        else {
            setTimeout(() => closeAction(), 150);
        }
    };
    // Using {once: true} in the options and recursively adding a new one-off eventListener for every click is necessary as the
    // component rerenders more than once when clicking the popup opener input. A better option would be eventually using the
    // useEffect hook with a dependency array of [state.focused], but for now this is compatible with our existing Class components.
    document.addEventListener("mousedown", eventListener, { once: true });
};
